@if (loading) {
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
} @else if (stats) {
  <div class="row g-4">
    <!-- Users Stats -->
    <div class="col-md-6 col-lg-4">
      <div class="card h-100">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="bg-primary bg-opacity-10 rounded-circle p-3 me-3">
              <i class="fa-solid fa-users text-primary fa-lg"></i>
            </div>
            <div>
              <h6 class="text-muted mb-0">{{ 'admin.dashboard.totalUsers' | translate }}</h6>
              <h2 class="mb-0">{{ stats.users.total }}</h2>
            </div>
          </div>
          <div class="d-flex justify-content-between text-sm">
            <span class="text-muted">{{ 'admin.dashboard.activeUsers' | translate }}</span>
            <span class="fw-semibold text-success">{{ stats.users.active }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Companies Stats -->
    <div class="col-md-6 col-lg-4">
      <div class="card h-100">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="bg-info bg-opacity-10 rounded-circle p-3 me-3">
              <i class="fa-solid fa-building text-info fa-lg"></i>
            </div>
            <div>
              <h6 class="text-muted mb-0">{{ 'admin.dashboard.totalCompanies' | translate }}</h6>
              <h2 class="mb-0">{{ stats.companies.total }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Trainers Stats -->
    <div class="col-md-6 col-lg-4">
      <div class="card h-100">
        <div class="card-body">
          <div class="d-flex align-items-center mb-3">
            <div class="bg-success bg-opacity-10 rounded-circle p-3 me-3">
              <i class="fa-solid fa-chalkboard-teacher text-success fa-lg"></i>
            </div>
            <div>
              <h6 class="text-muted mb-0">{{ 'admin.dashboard.activeTrainers' | translate }}</h6>
              <h2 class="mb-0">{{ stats.trainers.active }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Companies by Type -->
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h5 class="card-title mb-0">{{ 'admin.dashboard.companiesByType' | translate }}</h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            @for (type of ['stable', 'riding_club', 'riding_school', 'stores_services', 'unspecified']; track type) {
              <div class="col-6 col-md-4 col-lg-2">
                <div class="text-center p-3 bg-light rounded">
                  <h4 class="mb-1">{{ getCompanyCount(type) }}</h4>
                  <small class="text-muted">{{ getCompanyTypeLabel(type) }}</small>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
